module.exports = __webpack_public_path__ + "static/img/img_3.d7905701.jpg";